import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { ChangePasswordRequestSchema, ChangeUserPasswordUserTypeEnum } from '../client-sdk/api';

export const useChangePasswordApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


   const changePassword = useCallback(
    async (id: string, userType: ChangeUserPasswordUserTypeEnum, data: ChangePasswordRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.changeUserPassword(id, userType, data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    changePassword,   
    loading,
    error, 
  };
};
